export function getTitleLabel({
  translator: {
    __
  },
  productType,
  payload = {},
  process
}) {
  if (productType === 'domain' && process === 'create') {
    return __('Register');
  }
  if (productType === 'cloud') {
    return payload.isFirstServer ? __('Create') : __('Add funds');
  }
  if (productType === 'corporate' && process === 'create') {
    return __('Subscribe');
  }
  if (productType === 'mailboxv2' && process === 'update') {
    return __('Upgrade');
  }
  if (productType === 'mailboxv2' && process === 'renew' && payload.fake_renew) {
    return __('<for-translators-use>Verb: Convert mailbox</for-translators-use>Convert');
  }
  if (productType === 'domain_option' && process === 'create') {
    return __('Subscribe');
  }
  if (productType === 'marketplace' && process === 'update') {
    return __('Resize');
  }
  if (productType === 'tmch' && process === 'create') {
    return __('Register');
  }
  if (productType === 'paas' && process === 'create') {
    return __('Subscribe');
  }
  switch (process) {
    case 'add':
      return __('Add');
    case 'create':
      return __('Create');
    case 'renew':
      return __('Renew');
    case 'update':
      return __('Update');
    case 'restore':
      return __('Restore');
    case 'change_owner':
      return __('Owner change');
    case 'transfer':
      return __('Transfer');
    default:
      return process;
  }
}